<script>export let platform;
export let variant = "scroll";
export let active = true;
export let disable = false;
</script>

<style>.arrow-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.arrow-container:hover .scroll.desktop,
.arrow-container:hover .fastScroll.desktop {
  opacity: 1;
}
.scroll,
.fastScroll {
  background-color: hsl(var(--color-N100, var(--color-N77)));
  opacity: 0.5;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-size: contain;
          mask-size: contain;
  -webkit-mask-position: center;
          mask-position: center;
  width: 23px;
  margin-top: -5%;
}
.scroll.active,
.fastScroll.active {
  opacity: 0.8;
}
.scroll.disable,
.fastScroll.disable {
  opacity: 0.1;
}
.scroll {
  -webkit-mask-image: url("./img/Scroll.svg");
          mask-image: url("./img/Scroll.svg");
  aspect-ratio: 23/15;
}
.fastScroll {
  -webkit-mask-image: url("./img/FastScroll.svg");
          mask-image: url("./img/FastScroll.svg");
  aspect-ratio: 23/25;
}</style>

<div class="arrow-container">
  <div
    class={platform}
    class:scroll={variant === "scroll"}
    class:fastScroll={variant !== "scroll"}
    class:active
    class:disable />
</div>
